module.exports = __webpack_public_path__ + "static/media/icon-prev.7dddc230.svg";